module.exports = __webpack_public_path__ + "static/img/section-q5.84cc580.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/section-q5.jpg
// module id = x6jw
// module chunks = 1